import {useQuery} from '@tanstack/react-query';
import { authorizedGet } from '../functions/AuthService';

export const usePlantRecord = (params, options={}) => {
    return useQuery({
        queryKey: ['recordData', params.startDate, params.endDate, params.area],
        queryFn: async () => {
            const strParams = new URLSearchParams(params).toString();
            // console.log(`Dates: ${params.startDate} - ${params.endDate}`)
            const response = await authorizedGet(`/record/getData?${strParams}`);
            const resData = await response.body.json();
            // console.log("Data: ", resData);
            return resData;
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 60, //Keep it in memory for 1 hour
        refetchOnWindowFocus: false, //Prevent refreshing if the tab is clicked
        ...options
    });
}